module.exports = __webpack_public_path__ + "static/media/iphone 12 banner1.d3084699.jpg";